import script from "./IncentiveAdjustModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IncentiveAdjustModal.vue?vue&type=script&setup=true&lang=js"

import "./IncentiveAdjustModal.vue?vue&type=style&index=0&id=b9264c9c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9264c9c"]])

export default __exports__